import { render, staticRenderFns } from "./contact-request-snackbar.vue?vue&type=template&id=f128c52c&scoped=true&"
import script from "./contact-request-snackbar.vue?vue&type=script&lang=js&"
export * from "./contact-request-snackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f128c52c",
  null
  
)

export default component.exports